import React, { useEffect, useState } from "react";
import { Grid, Icon } from "semantic-ui-react";
import "./AcercaDeNosotros.scss";

export function AcercaDeNosotros() {
  const [tamanioIcono, setTamanioIcono] = useState(
    window.innerWidth <= 600 ? "huge" : "massive"
  );
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setTamanioIcono("huge");
      } else {
        setTamanioIcono("massive");
      }
    };

    window.addEventListener("resize", handleResize);
    // Limpia el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Grid className="gridPage" stackable>
      <Grid.Row style={{ padding: "14px" }}>
        <h2 className="tituloPage">
          ACERCA DE LA UNIDAD DE DOCENCIA Y CAPACITACIÓN
        </h2>
      </Grid.Row>

      <Grid.Row
        className="bordeGrid"
        textAlign="center"
        verticalAlign="middle"
        columns={2}
      >
        <Grid.Column width={2}>
          <Icon
            className="iconAcercaDe"
            name="calendar alternate"
            size={tamanioIcono}
          />
        </Grid.Column>

        <Grid.Column width={14}>
          <p className="descripcionPage">
            La Subdirección de Formación y Capacitación a través de la Unidad de
            Docencia implementa la AGENDA ÚNICA DE CAPACITACIÓN con el fin de
            acompañar las distintas áreas y programas del Ministerio de Salud
            con el objetivo de fortalecer los equipos de salud, desde la
            capacitación continua para dar respuesta a las necesidades de los
            servicios. La agenda única de capacitaciones técnico-pedagógicas
            abarca tanto las propuestas y programas de capacitación
            presenciales, semipresenciales y en línea, dado el importante
            desarrollo que han tenido en los últimos tiempos las tecnologías de
            la información y la comunicación para el aprendizaje.
          </p>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row
        className="bordeGrid"
        columns={2}
        textAlign="center"
        verticalAlign="middle"
      >
        <Grid.Column width={14}>
          <p className="descripcionPage">
            El objetivo es contribuir con el desarrollo de una estrategia
            integral de capacitación, orientada a las mejoras de servicios y a
            la calidad de atención de la salud fortaleciendo la educación
            permanente de su capital humano con el propósito de generar sinergia
            y articulación entre políticas y programas, como así mismo evitar
            acciones aisladas y/o descontextualizadas, en el marco del PLAN
            ESTRATÉGICO II.
          </p>
        </Grid.Column>

        <Grid.Column width={2}>
          <Icon
            className="iconAcercaDe"
            name="flag checkered"
            size={tamanioIcono}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
